module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"enterEmailToResetPassword":"Please enter your email to receive a link to reset your password.","checkEmail":"Check your email for further instructions on how to reset your password.","passwordRequestSubmitted":"Password changed successfully. You will now be redirected to the login page...","newPassword":"New Password","confirmPassword":"Confirm Password"}}')
  delete Component.options._Ctor
}
